import React from 'react';

/**
 * Daily Intake Output component
 */
const DailyIntakeOutput = (props) => (
  <div className="nppe2-fc-daily-intake-calc-header">

    <h2>{ props.data.label }</h2>
    <p>{ props.data.labelSmall }</p>

    <a href="#" aria-label={props.data.aria}>
        <div className="nppe2-fc-info-button nppe2-fc-info-button__daily-intake"
        onClick={ (e) => {
          props.openModalWithContent("DailyIntake");
          e.preventDefault();
        }}></div>
      </a>
    
    <hr/>
    <div className="row nppe2-fc-daily-intake-calc-header__red-box">
      <div className="col-xs-8">
        <p>{ props.data.energyRequirement }</p>
      </div>
      <div className="col-xs-4">
        <p>{Math.round(props.der)} { props.data.amountRequirement }</p>
      </div>
    </div>
  </div>
);

export default DailyIntakeOutput;



